import React from "react";
import Body from "./Body";

const CommunityOutreach = () => {
  const communityOutreachColumn = [
    {
      header: "Outreach for",
      accessor: "outreachFor",
      render: (_, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div>
            <h4>{row.title}</h4>
            <span style={{ color: "var(--tableColor)" }}>#</span>
            <span>{row.donationId}</span>
          </div>
        </div>
      ),
    },
    {
      header: "Time & date",
      accessor: "dateTime",
      render: (value) => (
        <span style={{ color: "black", fontSize: "0.8rem" }}>{value}</span>
      ),
    },
    {
      header: "Eqvt. amount (INR)",
      accessor: "amount",
      render: (value) => <span className="green-text">₹ {value}</span>,
    },
  ];

  const communityOutreachDonation = [
    {
      title: "Old people education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      title: "Old people education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      title: "Old people education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      title: "Old people education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      title: "Old people education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
  ];
  const _this = { communityOutreachColumn, communityOutreachDonation };
  return <Body {..._this} />;
};

export default CommunityOutreach;
